import { ERole } from "../enums/ERole";

export const getInitialRoute = (role: ERole): string => {
  if (role === ERole.ADMIN) return "/admin/dashboard";
  return "/";
};
